"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NotificationHandler = {
  notificationsArray: [],
  currentNotification: null,
  register: function register(alert) {
    this.currentNotification = alert;
  },
  unregister: function unregister() {
    this.currentNotification = null;
  },
  isShowing: function isShowing() {
    return this.currentNotification.isShowing();
  },
  queued: function queued() {
    return this.notificationsArray.length;
  },
  clearQueue: function clearQueue() {
    this.notificationsArray = [];
  },
  show: function show() {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var self = this;
    if (this.currentNotification === null) {
      return;
    }
    if (this.isShowing()) {
      if (!newState.hasOwnProperty("isExpress") || newState.hasOwnProperty("isExpress") && !newState.isExpress) {
        if (newState.hasOwnProperty("isPriority") && newState.isPriority) {
          this.notificationsArray.unshift(newState);
        } else {
          this.notificationsArray.push(newState);
        }
        return;
      }
    }
    if (newState !== null) {
      this.currentNotification.setNewState(newState);
    }
    setTimeout(function () {
      self.currentNotification.show();
    }, 100);
  },
  hide: function hide() {
    var _this = this;
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var self = this;
    if (this.currentNotification === null) {
      return;
    }
    if (newState !== null) {
      this.currentNotification.setNewState(newState);
    }
    setTimeout(function () {
      self.currentNotification.hide();
      if (self.notificationsArray.length > 0) {
        setTimeout(function () {
          self.show(_this.notificationsArray[0]);
          self.notificationsArray.shift();
        }, self.currentNotification.state.transitionTime);
      }
    }, 100);
  }
};
var _default = exports["default"] = NotificationHandler;